// extracted by mini-css-extract-plugin
export default {"input":"style_input__Q9xCL","error":"style_error__Kecin","text":"style_text__Jm2L2"};